export const INITIAL_LOOKAHEAD = 2;
export const NEXT_BATCH_SIZE = 5;
export const MAX_BATCH_SIZE = 10;
export const SETTLE_IN_VIEW_MS = 500;

export const RAIL_CARD_WIDTH = 320;
export const RAIL_CARD_WIDTH_DESKTOP = 380;

export const RAIL_SKELETON_HEIGHT = 317;
